import React from 'react';
import EventListener from 'react-event-listener';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';
import {
  BUTTON_DOWN_ARROW_CODE,
  BUTTON_LEFT_ARROW_CODE,
  BUTTON_OK_CODE,
  BUTTON_RIGHT_ARROW_CODE,
  BUTTON_UP_ARROW_CODE,
  BUTTON_ESC_CODE,
  BUTTON_TAB_CODE,
  BUTTON_HOME_CODE,
  BUTTON_EXIT_CODE,
  BUTTON_A_CODE,
  BUTTON_Z_CODE,
  BUTTON_SPACE_CODE,
} from '../helpers/pcKeyboard';
import { REMOTE_CONTROLLER_THROTTLE } from '../constants';

let remoteControllerActionAnimationFrame;

export class RemoteControllerComponent extends React.PureComponent {
  static throttledFn = (fn) =>
    throttle(
      (...args) => {
        if (remoteControllerActionAnimationFrame) {
          cancelAnimationFrame(remoteControllerActionAnimationFrame);
        }
        remoteControllerActionAnimationFrame = requestAnimationFrame(() => fn(...args));
      },
      REMOTE_CONTROLLER_THROTTLE,
      { trailing: false },
    );

  static propTypes = {
    isTOSNotificationVisible: PropTypes.bool.isRequired,
    onDPadLeftButtonPressed: PropTypes.func.isRequired,
    onDPadRightButtonPressed: PropTypes.func.isRequired,
    onUpButtonPressed: PropTypes.func.isRequired,
    onDownButtonPressed: PropTypes.func.isRequired,
    onOkButtonPressed: PropTypes.func.isRequired,
    onEscButtonPressed: PropTypes.func.isRequired,
    onTabButtonPressed: PropTypes.func.isRequired,
    onHomeButtonPressed: PropTypes.func.isRequired,
    onEndButtonPressed: PropTypes.func.isRequired,
    onCharacterButtonPressed: PropTypes.func.isRequired,
    onSpaceButtonPressed: PropTypes.func.isRequired,
  };

  getControllerKeyHandler = () => {
    const {
      onUpButtonPressed,
      onDownButtonPressed,
      onDPadLeftButtonPressed,
      onDPadRightButtonPressed,
      onOkButtonPressed,
      onEscButtonPressed,
      onTabButtonPressed,
      onHomeButtonPressed,
      onEndButtonPressed,
      onSpaceButtonPressed,
    } = this.props;

    return [
      ['up', BUTTON_UP_ARROW_CODE, onUpButtonPressed],
      ['down', BUTTON_DOWN_ARROW_CODE, onDownButtonPressed],
      ['dpadLeft', BUTTON_LEFT_ARROW_CODE, onDPadLeftButtonPressed],
      ['dpadRight', BUTTON_RIGHT_ARROW_CODE, onDPadRightButtonPressed],
      ['ok', BUTTON_OK_CODE, onOkButtonPressed],
      ['esc', BUTTON_ESC_CODE, onEscButtonPressed],
      ['tab', BUTTON_TAB_CODE, onTabButtonPressed],
      ['home', BUTTON_HOME_CODE, onHomeButtonPressed],
      ['end', BUTTON_EXIT_CODE, onEndButtonPressed],
      ['space', BUTTON_SPACE_CODE, onSpaceButtonPressed],
    ];
  };

  handleKeyDown = (controllerKeyHandler) =>
    RemoteControllerComponent.throttledFn((ev) => {
      const handler = controllerKeyHandler.find((i) => i.includes(ev.keyCode || ev.which || ev));
      if (this.props.isTOSNotificationVisible) {
        ev.stopPropagation();
        return false;
      }
      if (handler) {
        const [name, ...keyCodesAndFunction] = handler;
        const handlerFunction = keyCodesAndFunction.pop();
        console.log(`Executing key down handler: ${name}`);
        handlerFunction();
      } else {
        const characterCodes = [];
        for (let i = BUTTON_A_CODE; i <= BUTTON_Z_CODE; i += 1) {
          const charObj = [String.fromCharCode(i), i];
          characterCodes.push(charObj);
        }

        const characterFound = characterCodes.find((i) => i.includes(ev.keyCode || ev.which || ev));
        if (characterFound) {
          const { onCharacterButtonPressed } = this.props;
          onCharacterButtonPressed(String.fromCharCode(ev.keyCode));
        }
      }
    }, REMOTE_CONTROLLER_THROTTLE);

  render() {
    return (
      <EventListener
        target="window"
        onKeyDown={this.handleKeyDown(this.getControllerKeyHandler())}
      />
    );
  }
}
